import Socket from '../connection/socket';
import * as ChatActions from '../stores/actions/chat';
import type { ChatRoom } from '../stores/types/chat';
import { makeId } from '../stores/reducers/chat';
import { GreenroomState } from '../stores/types/types';
import { getState, socketListenerDispatch } from './socket-listener-main';
import logger from '../utils/logger-rum';

function handleNewRoom(room: ChatRoom) {
	const {
		SessionReducer: {
			user,
		},
	} = getState();

	if (room.participants.includes(user.gr_user)) {
		socketListenerDispatch(ChatActions.newRoom(room));
	}
}

function handleChatMessage(message: any) {
	const {
		TabsReducer: {
			activeTab,
		},
	} = getState();

	socketListenerDispatch(ChatActions.newMessage({ ...message, openTab: activeTab }));
}

function handleChatReload(message: any) {
	const msg = message?.message;

	if (msg?.room !== undefined && msg?.room !== null) {
		socketListenerDispatch(ChatActions.clearChatRoomMessages(msg.room, true));
		return;
	}

	if (!msg.chatId) {
		logger.error('Missing direct chat id.');
		return;
	}

	socketListenerDispatch(ChatActions.clearChatDirectChatId({ key: msg.chatId, all: true }));
}

function handleDeleteChatRoom(message: any) {
	const msg = message?.message;

	if (msg?.room !== undefined && msg?.room !== null) {
		socketListenerDispatch(ChatActions.deleteChatRoom(msg.room));
		socketListenerDispatch(ChatActions.setSelectedRoom(null));
		return;
	}
}

function handleRemoveMessage(
	message: {
		message: {
			from: string | null,
			messageId: number,
			roomId: number | undefined,
			dmKey: string,
		}
	},
) {
	const { SessionReducer: { session } } = getState() as GreenroomState;

	const {
		from,
		messageId,
		roomId,
		dmKey,
	} = message.message;

	if (from !== session) {
		socketListenerDispatch(ChatActions.removeChatMessage(messageId, roomId, dmKey));
	}
}

export default function Chat(socket: Socket) {
	const {
		SessionReducer: {
			embed,
		},
	} = getState();

	if (!embed) {
		socket.addListener('chat-message', handleChatMessage);
		socket.addListener('new-room', handleNewRoom);
		socket.addListener('reload-chat', handleChatReload);
		socket.addListener('remove-chat-message', handleRemoveMessage);
		socket.addListener('delete-chat-room', handleDeleteChatRoom);
	}
}
